import AnchorRounded from "@mui/icons-material/AnchorRounded";
import SailingRounded from "@mui/icons-material/SailingRounded";
import { Theme } from "@mui/material";

import styled from "styled-components";

export const ProgressContainer = styled.div`
	padding: 24px 8px 16px;
	position: relative;
`;

export const ProgressBackground = styled.div<{ theme: Theme }>`
	position: absolute;
	top: 26px;
	left: 0;
	right: 0;
	height: 6px;
	background-color: ${({ theme }) => theme.palette.mode === "dark" ? "#333" : "#e0e0e0"};
	border-radius: 3px;
	overflow: hidden;

	&::after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-image: linear-gradient(
			90deg,
			rgba(255, 255, 255, 0) 0%,
			rgba(255, 255, 255, 0.4) 50%,
			rgba(255, 255, 255, 0) 100%
		);
		background-size: 200% 100%;
		animation: shine 3s infinite linear;
	}

	@keyframes shine {
		from { background-position: 200% 0; }
		to { background-position: -200% 0; }
	}
`;

export const ProgressFill = styled.div<{ percentage: number }>`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	background: linear-gradient(90deg, #F39200 0%, #ffab40 100%);
	width: ${props => props.percentage}%;
	transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
	border-radius: 3px;
	box-shadow: 0 0 8px rgba(243, 146, 0, 0.4);
`;

export const DotContainer = styled.div<{ position: number; isHighlighted?: boolean }>`
	position: absolute;
	top: 23px;
	left: ${props => props.position}%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	z-index: ${props => props.isHighlighted ? 5 : 2};
`;

export const ActiveCallArrow = styled.div<{ percentage: number; hideCircle?: boolean }>`
	position: absolute;
	top: 0;
	left: ${props => props.percentage}%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	transition: left 0.8s cubic-bezier(0.4, 0, 0.2, 1);
	z-index: 3;

	&::before {
		content: "";
		position: absolute;
		top: 29px;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 20px;
		height: 20px;
		background-color: white;
		border-radius: 50%;
		z-index: -1;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		display: ${props => props.hideCircle ? "none" : "block"};
	}
`;

export const SailingIcon = styled(SailingRounded)`
	font-size: 22px !important;
	margin-top: 16px;
	filter: drop-shadow(0 0 2px white);
	animation: sway 3s ease-in-out forwards;

	@keyframes sway {
		0% { transform: rotate(0deg); }
		25% { transform: rotate(-8deg); }
		75% { transform: rotate(8deg); }
		100% { transform: rotate(0deg); }
	}
`;

export const AnchorIcon = styled(AnchorRounded)`
	font-size: 18px !important;
	margin-top: 18px;
	filter: drop-shadow(0 0 2px white) drop-shadow(0 1px 2px rgba(0,0,0,0.1));
	animation: pulseSmall 2s infinite ease-in-out;

	@keyframes pulseSmall {
		0%, 100% { transform: scale(1); }
		50% { transform: scale(1.15); }
	}
`;

export const TooltipContent = styled.span`
	display: flex;
	text-align: center;
	flex-direction: column;
`;

export const ProgressDot = styled.div<{ dotColor: string; isVisible?: boolean, isHighlighted?: boolean }>`
	width: ${props => props.isHighlighted ? "14px" : "12px"};
	height: ${props => props.isHighlighted ? "14px" : "12px"};
	border-radius: 50%;
	background-color: ${props => props.dotColor};
	border: 2px solid white;
	box-shadow: 0 2px 4px rgba(0,0,0,0.2);
	transition: all 0.3s ease;
	opacity: ${props => props.isVisible === false ? 0 : 1};
	visibility: ${props => props.isVisible === false ? "hidden" : "visible"};
	${props => props.isHighlighted && `
      animation: pulseFinish 2s ease-in-out 2.5;
      animation: pulseFinish 2s ease-in-out 2.5;
      animation-fill-mode: forwards;
     z-index: 5;
`}
	&:hover {
		@keyframes pulseFinish {
		0% { transform: scale(1); box-shadow: 0 0 0 0px rgba(211, 125, 0, 0.4), 0 2px 4px rgba(0,0,0,0.3); }
		50% { transform: scale(1.3); box-shadow: 0 0 0 10px rgba(211, 125, 0, 0), 0 2px 4px rgba(0,0,0,0.3); }
		100% { transform: scale(1); box-shadow: 0 0 0 0px rgba(211, 125, 0, 0), 0 2px 4px rgba(0,0,0,0.3); }
		100% { transform: scale(1.15); box-shadow: 0 0 0 0px rgba(211, 125, 0, 0), 0 2px 4px rgba(0,0,0,0.3); }
	}
`;

export const VoyageBoundariesContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: start;
	margin-top: 8px;
`;

export const BoundaryInfo = styled.div<{ align: "start" | "end"; isFinished?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: ${props => props.align === "start" ? "flex-start" : "flex-end"};

	b {
		font-weight: 600;
		color: ${props => props.isFinished ? "#D37D00" : "#333"};
		font-size: 0.9rem;
		transition: color 0.3s ease;
	}

	small {
		font-size: 0.75rem;
		color: ${props => props.isFinished ? "#D37D00" : "#666"};
		margin-top: 2px;
		transition: color 0.3s ease;
	}
`;
